/* eslint-disable camelcase */
import { errorLogger } from '@ajaibid/utils';
import fetcher from '@helpers/fetcher';

/**
 * @param {string} idxTradeNo
 */
function getUrl(idxTradeNo) {
  return `v1/stock/historytrade-filter/${idxTradeNo}`;
}

/**
 * @typedef   {object}    RegularHistoryDetailParams
 * @property  {string}    startDate     Format: YYYY-MM-DD
 * @property  {string}    idxTradeNo    (Ex: "202306140000017210")
 */

/**
 * @typedef   {object}  RegularHistoryDetail
 *
 * @property  {string}     trade_date         (Ex: "2023-06-23T09:51:01.000+07:00")
 * @property  {string}     order_no           (Ex: "20012")
 * @property  {string}     stock              (Ex: "GOTO")
 * @property  {string}     idx_trade_no       (Ex: "202306230000000344")
 * @property  {string}     idx_order_no       (Ex: "202306230000017184")
 * @property  {string}     transaction_type   (Ex: "1")
 * @property  {string}     market_type        (Ex: "0RG")
 * @property  {number}     lot                (Ex: 1)
 * @property  {number}     shares             (Ex: 1)
 * @property  {number}     price_matched      (Ex: 120.0)
 * @property  {number}     total_price        (Ex: 12000)
 * @property  {number}     fee                (Ex: 0.3015636000000000000)
 * @property  {string}     tradetime          (Ex: "09:51:01")
 * @property  {string}     counter            (Ex: "--")
 * @property  {string}     status_description (Ex: "Matched")
 */

/**
 * @typedef   {object}  RegularHistoryDetailResponse
 *
 * @property  {object}                data
 * @property  {string}                data.errCode      (Ex: "EC0000000")
 * @property  {string}                data.errMessage   (Ex: "APPROVED/OK")
 * @property  {RegularHistoryDetail}  data.result
 *
 * @property  {number}                status            (Ex: 200)
 * @property  {string}                statusText        (Ex: '')
 */

/**
 *
 * @param {string}                      url
 * @param {Omit<RegularHistoryDetailParams, 'idxTradeNo'>}  detailParams
 * @returns
 */
function callbackFetch(url, { startDate }) {
  return async () => {
    try {
      /**
       * @type {RegularHistoryDetailResponse}
       */
      const res = await fetcher.get(url, {
        params: {
          start_date: startDate,
        },
      });

      return res.data;
    } catch (err) {
      errorLogger('ERROR_API', err.message);
      throw err;
    }
  };
}

/**
 * @param {RegularHistoryDetailParams} detailParams
 * @returns
 */
export default function getV1StockHistorytradefilterById({ idxTradeNo, ...detailParams }) {
  const url = getUrl(idxTradeNo);
  const cb = callbackFetch(url, detailParams);
  const key = [url, JSON.stringify(detailParams)];

  return { cb, key };
}
